export const partFinderCatalogPath = () => '/part-finder';

export const partFinderFamilyPath = (id: number | string = ':id') => `/part-finder/family/${id}`;

export const partFinderFamilyPartsPath = (id: number | string = ':id') =>
  `/part-finder/family/${id}/parts`;
